export default __webpack_public_path__ + "static/media/upper-back-img.5a2b1c86.webp";